goog.provide("shadow.js.shim.module$$mui$material$AccordionDetails");
goog.provide("module$shadow_js_shim_module$$mui$material$AccordionDetails");
shadow.js.shim.module$$mui$material$AccordionDetails = shadow.js.nativeProvides["@mui/material/AccordionDetails"] = shadow$bridge("@mui/material/AccordionDetails");
module$shadow_js_shim_module$$mui$material$AccordionDetails.default = shadow.js.shim.module$$mui$material$AccordionDetails;
